import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  root: {},
  container: {
    height:170,
  },
  // card: {
  //   width: '80%',
  //   margin:"0 auto",
  //   height: '100%',
  //   borderRadius: 3,
  //   padding: 8,
  //   display: 'flex',
  //   boxShadow: '6px 8px 6px 5px rgb(0 0 0 / 18%)',
  //   flexDirection:'column',
  //   justifyContent:'center',
  //   transition: 'background 0.3s ease',
  //   background:
  //   "linear-gradient(38deg, rgba(10,110,112,1) 0%, rgba(22,198,227,0.8436624649859944) 65%)",
  //   '&:hover': {
  //     background:
  //     "linear-gradient(38deg, rgba(203,93,9,1) 0%, rgba(242,142,10,0.8436624649859944) 65%) !important",
  //       },
  // },
  // nameLabel: {
  //   '& .MuiTypography-root': {
  //     paddingBlockEnd: 8,
  //     fontWeight: 800,
  //     color: '#fff',
  //     fontSize: 15,
  //     textTransform: 'uppercase',
  //   },
  // },
  // count: {
  //   display:'flex',
  //   justifyContent:'space-between',
  //   alignItems:'center',
  //   '& .MuiTypography-root': {
  //     fontWeight: 500,
  //     color: '#fff',
  //   },
  //   '& .MuiSvgIcon-root':{
  //     fontSize: 65,
  //     color: '#f0f8ffbf',
  //   }
  // },


   card: {
    width: "95%",
    margin: "0 auto",
    height: "100%",
    borderRadius: 10,
    padding: 16,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    background: "#e9ecef",
    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
    position: "relative",
    transition: "all 0.2s ease-in-out",

    "&:hover": {
      transform: "translateY(-3px)",
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    },
  },

  nameLabel: {
    "& .MuiTypography-root": {
      fontSize: 14,
      fontWeight: 700,
      color: "#111",
    },
  },

  count: {
    "& .MuiTypography-root": {
      fontSize: 28,
      fontWeight: 700,
      color: "#111",
    },
  },

  iconWrapper: {
    position: "absolute",
    right: 12,
    bottom: 12,

    "& .MuiSvgIcon-root": {
      fontSize: 36,
      opacity: 0.7,
    },
  },
}))

export default useStyles
